import { useCallback, useMemo } from 'react';

export const usePreprocessedDict = (preprocessedDict, getWords) => {
  const findWords = useCallback(
    ({ node, offset }) => {
      const results = preprocessedDict.get(node)?.[offset];

      if (!results) {
        return null;
      }

      const [firstResult] = sortResults(results);
      const { textPath } = firstResult;

      return {
        ...getWords(results),
        range: getRangeByTextPath(textPath),
      };
    },
    [preprocessedDict, getWords]
  );

  return useMemo(
    () => ({
      findWords,
    }),
    [findWords]
  );
};

const sortResults = (results) => {
  return results.sort((resultA, resultB) => {
    const { textPath: textPathA } = resultA;
    const { textPath: textPathB } = resultB;

    const firstTextOffsetDiff = textPathA[0].textOffset - textPathB[0].textOffset;

    if (firstTextOffsetDiff !== 0) {
      return firstTextOffsetDiff;
    }

    const firstCharOffsetDiff = textPathA[0].charOffset - textPathB[0].charOffset;

    if (firstCharOffsetDiff !== 0) {
      return firstCharOffsetDiff;
    }

    const lastIndexA = textPathA.length - 1;
    const lastIndexB = textPathB.length - 1;

    const lastTextOffsetDiff = textPathB[lastIndexB].textOffset - textPathA[lastIndexA].textOffset;

    if (lastTextOffsetDiff !== 0) {
      return lastTextOffsetDiff;
    }

    const lastCharOffsetDiff = textPathB[lastIndexB].charOffset - textPathA[lastIndexA].charOffset;

    if (lastCharOffsetDiff !== 0) {
      return lastCharOffsetDiff;
    }

    return 0;
  });
};

const getRangeByTextPath = (textPath) => {
  const startPath = textPath[0];
  const endPath = textPath[textPath.length - 1];

  const range = document.createRange();
  range.setStart(startPath.textNode, startPath.charOffset);
  range.setEnd(endPath.textNode, endPath.charOffset + 1);

  return range;
};
